// extracted by mini-css-extract-plugin
export default {"formLabel":"ResetPasswordForm_formLabel__rmpHk","formAlert":"ResetPasswordForm_formAlert__d25Mz","submitButtonContainer":"ResetPasswordForm_submitButtonContainer__mGUvM"};